import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {LoadingController} from 'ionic-angular';

@Injectable()
export class LoaderServiceProvider {
  public isOpen: number = 0;
  private isClosed: boolean = true;
  loader: any;

  constructor(public loading: LoadingController) {
  }

  public showLoader(content = "Please wait...") {
    if (!this.isOpen) {
      this.loader = this.loading.create({
        content: content
        //dismissOnPageChange:true
      });
      this.loader.present();
    }

    this.isClosed = false;
    this.isOpen++;
  }

  public dismissLoader() {
    if(this.isOpen > 0) {
      this.isOpen--;
    }
    if (this.isOpen === 0 && !this.isClosed) {
      this.loader.dismiss();
      this.isClosed = true;
    }
  }


}



// WEBPACK FOOTER //
// ./src/providers/loader-service/loader-service.ts